// Paths for the Water Sensors pages (water_level_service via backend_main)
export const WATER_SENSORS_PATH = "/facility/utility_management/meter_management/water_sensors";
export const waterSensorsTabPath = (tab) => `${WATER_SENSORS_PATH}?tab=${tab}`;
export const viewTankPath = (tankId) => `${WATER_SENSORS_PATH}/view_tank/${tankId}`;
